<template>
	<action-card
		v-if="deliverables.length"
		:title="taskMode ? $t('projects.tasks') : $t('nav.projects')"
		:icon="taskMode ? 'clipboard-list' : 'folder-kanban'"
		:count="deliverables.length"
		@open="$router.push('/projects')"
	>
		<button
			v-for="deliverable in visibleDeliverables"
			:key="deliverable.id"
			type="button"
			class="portal-action-row"
			@click="openDeliverable(deliverable)"
		>
			<span class="action-row-copy">
				<strong>{{ deliverable.name }}</strong>
				<small v-if="taskMode && taskContext(deliverable)">{{ taskContext(deliverable) }}</small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import { DateTime } from 'luxon';
	import ProjectService from '@/modules/projects/ProjectService';
	import DeliverableDetail from '@/modules/projects/deliverable/DeliverableDetail';
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';

	export default {
		name: 'Deliverables',

		props: {
			deliverables: { type: Array, required: true },
			taskMode: { type: Boolean, default: false },
		},

		components: { ActionCard },

		data() {
			return {
				projectService: new ProjectService(),
				projectTypes: [],
				projects: [],
			};
		},

		mounted() {
			this.getProjectTypes();
			this.getProjectList();
		},

		methods: {
			taskContext(deliverable) {
				const project = this.projects.find((item) => String(item.id) === String(deliverable.projectId));
				return [
					project && project.name,
					deliverable.dueDate
						? `${this.$t('global.due')} ${DateTime.fromISO(deliverable.dueDate).toFormat('MMM dd')}`
						: null,
				]
					.filter(Boolean)
					.join(' · ');
			},

			getProjectList() {
				this.projectService.getProjects().then((response) => {
					this.projects = response.data;
				});
			},

			getProjectTypes() {
				this.projectService.getProjectTypes().then((response) => {
					this.projectTypes = response.data;
				});
			},

			openDeliverable(deliverable) {
				const projectType = this.projectTypes.find((type) => type.id === deliverable.projectTypeId);
				const binding = {
					origDeliverable: deliverable,
					project: this.projects.find((project) => project.id === deliverable.projectId),
					statusList: projectType ? projectType.statusList : [],
				};

				this.$store.state.globalModalController
					.openModal(DeliverableDetail, binding, true, false, 'right-panel')
					.then(() => this.$emit('refresh'));
			},
		},

		computed: {
			visibleDeliverables() {
				return this.deliverables.slice(0, 5);
			},
		},
	};
</script>
